import Vue from "vue";
import Router from "vue-router";
import PMain from './../src/components/pages/terminal/p-main/p-main';
import PTiles from './../src/components/pages/terminal/p-tiles/p-tiles';
import PTerminal from './../src/components/pages/p-terminal/p-terminal';
import PSearchbar from './../src/components/pages/terminal/p-searchbar/p-searchbar';
import PVideoShop from './components/pages/terminal/p-video-shop/p-video-shop';
import PStandardGuide from './../src/components/pages/terminal/p-standard-guide/p-standard-guide';
import OMainFrame from './../src/components/organisms/o-main-frame/o-main-frame';

const OPathOtg = () => import('./../src/components/organisms/o-path-otg');
const PIntegrations = () => import('./../src/components/pages/p-integrations');
const PPosters = () => import('./../src/components/pages/p-posters');
const PPostersStart = () => import('./../src/components/pages/p-posters-start');
const OObjectInfo = () => import('./../src/components/organisms/o-object-info');
const PWebIntegration = () => import('./../src/components/pages/p-web-integration');
const OPathSettings = () => import('./../src/components/organisms/o-path-settings');
const PTransport = () => import('./../src/components/pages/p-transport/p-transport');
const OPathStart = () => import('./../src/components/organisms/o-path-start');
const OSearchPanelOtg = () => import('./../src/components/organisms/o-search-panel-otg');

import {
    TERMINAL_MOVIES,
    TERMINAL_VIDEOSHOP,
    TERMINAL_MOVIE_DETAILS
} from "@/utils/constants/pages";

Vue.use(Router);
const navigationMode = process.env.VUE_APP_OFFLINE_MODE ? "hash" : "history";
export default new Router({
    mode: navigationMode,
    routes: [
        {
            path: "/",
            name: "hospital",
            component:() =>  import ("./components/pages/p-root/p-root"),
            children: [
                {
                    path: "terminal-:terminalCode*",
                    name: "terminal.root.legacy",
                    redirect: (to) => `/map-79962313/terminal-${to.params.terminalCode}/start`,
                },
                {
                    path: "terminal-:terminalCode/start",
                    name: "terminal.start.legacy",
                    redirect: (to) => `/map-79962313/terminal-${to.params.terminalCode}/start`,
                },
                {
                    path: "map-:mapId/terminal-:terminalCode",
                    name: "terminal.root",
                    component: PTerminal,
                    props: true,
                    redirect: {
                        name:"terminal.start"
                    },
                    children: [
                        {
                            path: "start",
                            name: "terminal.start",
                            component: PMain
                        },
                        {
                            path: ":path/categoryId-:categoryId",
                            name: 'terminal.tiles',
                            component: PTiles
                        },
                        {
                            path: "searchbar/categoryId-:categoryId",
                            name: "terminal.searchbar",
                            component: PSearchbar
                        },
                        {
                            path: "guide/:mode/id-:itemId",
                            name: "terminal.standard.guide",
                            components: {
                                guide: PStandardGuide
                            }
                        },
                        {
                            path: "care",
                            name: "terminal.care",
                            component: () =>
                                import("./components/unique-organisms/o-care/o-care")
                        },
                        {
                            path: "search",
                            name: "terminal.search",
                            component: () =>
                                import("./components/unique-organisms/o-search/o-search")
                        },
                        {
                            path: 'videoshop',
                            name: TERMINAL_VIDEOSHOP,
                            component: PVideoShop,
                            redirect: {
                                name: 'terminal.movies'
                            },
                            children: [{
                                path: 'movies',
                                name: TERMINAL_MOVIES,
                                component: OMainFrame,
                                props: {
                                    view: 'videoGrid'
                                }
                            }, {
                                path: 'details',
                                name: TERMINAL_MOVIE_DETAILS,
                                component: OMainFrame,
                                props: {
                                    view: 'movieDetails'
                                }
                            }]
                        },
                        {
                            path: 'transport',
                            name: 'terminal.transport',
                            component: PTransport
                        }
                        /* {
                            path: "guide/:type/id-:id",
                            name: "terminal.guide",
                            component: () =>
                                import("./components/unique-organisms/o-guide/o-guide")
                        }*/
                    ]
                },
                {
                    path: 'map-:mapId',
                    name: 'detect.theme',
                    component:() =>  import ("./components/pages/p-define-theme/p-define-theme"),
                    props: true,
                    children: [
                        {
                            path: 'web',
                            name: 'web.root',
                            component:() =>  import ("./components/pages/p-desktop/p-desktop"),
                            redirect: 'web/start',
                            children: [
                                {
                                    path: 'start',
                                    name: 'web.start',
                                    component:() =>  import ("./components/unique-organisms/o-d-storo-start/o-d-storo-start")
                                },
                                {
                                    path: 'explore',
                                    name: 'web.explore',
                                    component:() =>  import ("./components/unique-organisms/o-d-explore/o-d-explore")
                                },
                                {
                                    path: 'care',
                                    name: 'web.care',
                                    component:() =>  import ("./components/unique-organisms/o-d-care/o-d-care")
                                },
                                {
                                    path: 'category/:categoryId',
                                    name: 'web.category',
                                    component:() =>  import ("./components/unique-organisms/o-d-category/o-d-category")
                                },
                                {
                                    path: 'services',
                                    name: 'web.services',
                                    component:() =>  import ("./components/unique-organisms/o-d-services/o-d-services")
                                },
                                {
                                    path: 'service',
                                    name: 'web.service',
                                    component: () => import ("./components/unique-organisms/o-d-service/o-d-service")
                                },
                                {
                                    path: 'search',
                                    name: 'web.search',
                                    component: () => import ("./components/unique-organisms/o-d-search/o-d-search")
                                },
                                {
                                    path: 'guide/:type',
                                    name: 'web.guide',
                                    component:() =>  import ("./components/unique-organisms/o-d-guide/o-d-guide")
                                }
                            ]
                        },
                        {
                            path: "mobile",
                            name: "mobile.root",
                            component:() =>  import ("./components/pages/p-mobile/p-mobile"),
                            redirect: { name: 'mobile.home' },
                            children: [
                                {
                                    path: 'home',
                                    name: 'mobile.home',
                                    component:() =>  import ("./components/pages/p-mobile-menu/p-mobile-menu"),
                                },
                                {
                                    path: 'explore',
                                    name: 'mobile.explore',
                                    component:() =>  import ("./components/pages/p-mobile-explore/p-mobile-explore"),
                                },
                                {
                                    path: 'services',
                                    name: 'mobile.services',
                                    component:() =>  import ("./components/unique-organisms/o-mobile-services/o-mobile-services"),
                                },
                                {
                                    path: "service",
                                    name: "mobile.service",
                                    component: () => import ("./components/unique-organisms/o-m-service/o-m-service"),
                                },
                                {
                                    path: 'category/:categoryId',
                                    name: 'mobile.category',
                                    component:() =>  import ("./components/unique-organisms/o-mobile-care/o-mobile-care"),
                                    params: true,
                                },
                                {
                                    path: 'search',
                                    name: 'mobile.search',
                                    component:() =>  import ("./components/unique-organisms/o-m-searchbar/o-m-searchbar")
                                },
                                {
                                    path: 'search/category/:categoryId',
                                    name: 'mobile.search.category',
                                    component:() =>  import ("./components/unique-organisms/o-mobile-searchbar-care/o-mobile-searchbar-care")
                                },
                                {
                                    path: 'guide/:type',
                                    name: 'mobile.guide',
                                    component:() =>  import ("./components/unique-organisms/o-mobile-guide/o-mobile-guide")
                                }
                            ]
                        }
                    ]
                }, {
                    name: 'integrations',
                    path: 'map-:mapId/integrations',
                    component: PIntegrations,
                    redirect: { name: 'web.integration'},
                    children: [{
                        name: 'web.integration.catalogue',
                        path: 'web/catalogue',
                        redirect: {name: 'web.integration.catalogue.list'},
                        component: PWebIntegration,
                        children : [{
                            name: 'web.integration.catalogue.info',
                            path: 'info',
                            component: OObjectInfo
                        }, {
                            name: 'web.integration.catalogue.settings',
                            path: 'path-settings',
                            component: OPathSettings
                        }, {
                            name: 'web.integration.catalogue.start',
                            path: 'path-start',
                            component: OPathStart
                        }, {
                            name: 'web.integration.catalogue.path',
                            path: 'path',
                            component: OPathOtg,
                            beforeEnter: (to, from, next) => {
                                const {query, params} = to;

                                if(!query) {
                                    return next({name: 'web.integration.catalogue.list', params})
                                } 

                                const {mFrom, mTo, t} = query;
                                if(!mFrom && (mTo || t)) {
                                    return next({name: 'web.integration.catalogue.settings', query, params})
                                } 
                                if(!mTo && !t) {
                                    return next({name: 'web.integration.catalogue.list', params})
                                }
                                
                                next()
                            }
                        }, {
                            name: 'web.integration.catalogue.list',
                            path: 'list',
                            component: OSearchPanelOtg
                        }]
                    },
                    {
                        name: 'web.integration.store',
                        path: 'web/store',
                        component: PWebIntegration,
                        children : [{
                            name: 'web.integration.store.info',
                            path: 'info',
                            component: OObjectInfo
                        }, {
                            name: 'web.integration.store.settings',
                            path: 'path-settings',
                            component: OPathSettings
                        }, {
                            name: 'web.integration.store.path',
                            path: 'path',
                            component: OPathOtg,
                            beforeEnter: (to, from, next) => {
                                const {query, params} = to;
                                if(!query) {
                                    return next({name: 'web.integration.catalogue.list', params})
                                } 

                                const {mFrom, mTo, t} = query;
                                if(!mFrom && (mTo || t)) {
                                    return next({name: 'web.integration.store.settings', query, params})
                                } 
                                if(!mTo && !t) {
                                    return next({name: 'web.integration.catalogue.list', params})
                                } 
                                
                                next()
                            }
                        }]
                    },
                    {
                        name: 'web.integration',
                        path: 'web',
                        component: PWebIntegration,
                        children : [{
                            name: 'web.integration.info',
                            path: 'info',
                            component: OObjectInfo,
                            redirect: {name: 'web.integration.store.info'}
                        }, {
                            name: 'web.path.settings',
                            path: 'path-settings',
                            component: OPathSettings,
                            redirect: to => {
                                if(to.query.t) {
                                    return {name: 'web.integration.store.settings'}
                                } else {
                                    return {name: 'web.integration.catalogue.settings'}
                                }
                            }
                        }, {
                            name: 'web.path.start',
                            path: 'path-start',
                            component: OPathStart,
                            redirect: {name: 'web.integration.catalogue.start'}
                        }, {
                            name: 'web.path',
                            path: 'path',
                            component: OPathOtg,
                            redirect: to => {
                                if(to.query.t) {
                                    return {name: 'web.integration.store.path'}
                                } else {
                                    return {name: 'web.integration.catalogue.path'}
                                }
                            }
                        }, {
                            // name: 'web.integration.catalogue',
                            path: 'catalogue',
                            component: OSearchPanelOtg,
                            redirect: {name: 'web.integration.catalogue.list'}
                        }]
                    }]
                }, {
                    name: 'posters',
                    path: 'map-:mapId/posters/:posterId/',
                    component: PPosters,
                    props: true,
                    redirect: { name: 'posters.start'},
                    children: [{
                        name: 'posters.start',
                        path: 'start',
                        component: PPostersStart,
                        children : []
                    }]
                }, {
                    path: 'qr-:qrId',
                    name: 'qr.controller',
                    component:() =>  import ("./components/pages/p-qr-controller/p-qr-controller"),
                    props: true
                }
            ]
        },
        {
            path: '*',
            redirect: '/'
        }
    ]
});
